import {
  FETCH_SUBCATEGORYLIST_REQUEST,
  FETCH_SUBCATEGORYLIST_SUCCESS,
  FETCH_SUBCATEGORYLIST_FAILURE,
} from "./subcategoryListTypes";
import api from "../../utils/Api";
import axios from 'axios';

export const fetchSubCategoryListRequest = () => {
  return {
    type: FETCH_SUBCATEGORYLIST_REQUEST,
  };
};

export const fetchSubCategoryListSuccess = (subcategoryList) => {
  return {
    type: FETCH_SUBCATEGORYLIST_SUCCESS,
    payload: subcategoryList,
  };
};

export const fetchSubCategoryListFailure = (error) => {
  return {
    type: FETCH_SUBCATEGORYLIST_FAILURE,
    payload: error,
  };
};

const CancelToken = axios.CancelToken;
let cancelRequest;
export const fetchSubCategoryList = (searchKey, sortBy, page) => {
  //cancel previous request if multiple hits done.
  cancelRequest && cancelRequest();
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchSubCategoryListRequest);
    try {
      const response = await api.get(
        "inventory/subcategory?search_key=" +
          searchKey +
          "&sort_by=" +
          sortBy +
          "&page=" +
          page,        
          {
          headers: headers,
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c;
        })
        }
      );
      const subcategoryList = response.data.data;
     // console.log("************* subcategoryList", subcategoryList);
      dispatch(fetchSubCategoryListSuccess(subcategoryList));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Error: ', error.message); // => prints: Api is being canceled
      } 
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchSubCategoryListFailure(errorMsg));
    }
  };
};
